const faqSchema = () => {
  const faqAccordion = $('.faq-section .accordion-wrapper');
  const faqRichText = $('.faq-section .faq-wrapper');
  const entities = [];
  if (faqAccordion.length) {
    for (var i = 0; i < faqAccordion.length; i++) {
      const question = faqAccordion[i].querySelector('.accordion-heading').textContent;
      const answer = faqAccordion[i].querySelector('.accordion-content .accordion-text').textContent;
      addEntity(question, answer);
    }
  }
  if (faqRichText.length) {
    for (var j = 0; j < faqRichText.length; j++) {
      const question = getContent(faqRichText[j].querySelectorAll('h5'));
      const answer = getContent(faqRichText[j].querySelectorAll('p'));
      addEntity(question, answer);
    }
  }
  function getContent (elements) {
    let result = '';
    for (var i = 0; i < elements.length; i++) {
      result = result + elements[i].textContent;
    }
    return result;
  }
  function addEntity (question, answer) {
    entities.push({
      '@type': 'Question',
      name: formatString(question),
      acceptedAnswer: {
        '@type': 'Answer',
        text: formatString(answer)
      }
    });
  }
  function formatString (string) {
    return string.replace(/\s+|\n/g, char => char === '\n' ? '' : ' ').trim();
  }
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: entities
  };
  appendSchema(faqSchema);
};

const breadcrumbSchema = () => {
  const breadcrumbSection = $('.breadcrumb-section');
  const breadcrumbSchema = [];
  for (var i = 0; i < breadcrumbSection.length; i++) {
    const breadcrumbList = [];
    const breadcrumb = breadcrumbSection[i].querySelectorAll('a.breadcrumb-item:not(.breadcrumb-current)');
    for (var j = 0; j < breadcrumb.length; j++) {
      breadcrumbList.push({
        '@type': 'ListItem',
        position: j + 1,
        name: breadcrumb[j].textContent,
        item: window.location.origin + breadcrumb[j].getAttribute('href')
      });
    }
    breadcrumbSchema.push({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbList
    });
  }
  appendSchema((breadcrumbSchema.length > 1) ? breadcrumbSchema : breadcrumbSchema[0]);
};

const appendSchema = (schema) => {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(schema);
  jQuery('body').append(script);
};

export const generateSchemaMarkup = () => {
  if ($('.faq-section').length) {
    faqSchema();
  }
  if ($('.breadcrumb-section').length) {
    breadcrumbSchema();
  }
};
